import logo from './logo.svg';
import './App.css';
import Page from './Page';
function App() {
  return (
    <div className="App">
      <Page></Page>
    </div>
  );
}

export default App;
